// extracted by mini-css-extract-plugin
export var container = "GPReports-module--container--EmBnN";
export var content = "GPReports-module--content--UDpYF";
export var noOrders = "GPReports-module--noOrders--maY9E";
export var subHeader = "GPReports-module--subHeader--U23FN";